import { useState, useEffect } from "react";
import { useAddNewBlogMutation } from "./blogApiSlice";
import {
  useGetTagQuery,
  useAddNewTagMutation,
  useDeleteTagMutation,
} from "./useTagApiSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// import { useHistory } from "react-router-dom";
const Create = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [author, setAuthor] = useState("Veljko");
  const [date, setDate] = useState();

  const [tags, setTags] = useState([]); //Dodavani tagovi... OBRNUO SAM
  const [newTag, setNewTag] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  //Za upload slike
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  const [isLoadingImg, setIsLoadingImg] = useState(true);
  const [postImage, setPostImage] = useState({ myFile: "" });

  const [isPrivate, setIsPrivate] = useState(false);

  const handleSwitchChange = () => {
    setIsPrivate(!isPrivate);
  };

  //   const history = useHistory();

  //Za dodavanje bloga
  const [
    addBlog,
    {
      isSuccess: isSuccessAddBlog,
      isError: isErrorAddBlog,
      error: errorAddBlog,
      data: dataAddBlog,
    },
  ] = useAddNewBlogMutation();

  const [
    addTag,
    {
      isSuccess: isSuccessAddTag,
      isError: isErrorAddTag,
      error: errorAddTag,
      data: dataAddTag,
    },
  ] = useAddNewTagMutation();

  const [
    deleteTag,
    {
      isSuccess: isSuccessDeleteTag,
      isError: isErrorDeleteTag,
      error: errorDeleteTag,
      data: dataDeleteTag,
    },
  ] = useDeleteTagMutation();

  const {
    isSuccess: isSuccessGetTag,
    isError: isErrorGetTag,
    error: getTagError,
    data: getTagData,
  } = useGetTagQuery();

  useEffect(() => {
    if (isSuccessAddBlog) {
      alert(dataAddBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddBlog) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddBlog?.data?.message);
    }
  }, [isSuccessAddBlog, isErrorAddBlog, errorAddBlog, dataAddBlog]);

  useEffect(() => {
    if (isSuccessAddTag) {
      //   alert(dataAddTag.message.toString());
      // setPrimCiljNaziv('')
      console.log(dataAddTag.message.toString());
    }

    if (isErrorAddTag) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddTag?.data?.message);
    }
  }, [isSuccessAddTag, isErrorAddTag, errorAddTag, dataAddTag]);

  useEffect(() => {
    if (isSuccessDeleteTag) {
      //   alert(dataAddTag.message.toString());
      // setPrimCiljNaziv('')
      //   console.log(dataDeleteTag.message.toString());
    }

    if (isErrorDeleteTag) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorDeleteTag?.data?.message);
    }
  }, [isSuccessDeleteTag, isErrorDeleteTag, errorDeleteTag, dataDeleteTag]);

  useEffect(() => {
    if (isSuccessGetTag) {
      //   alert(getTagData.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      setTags(Object.values(getTagData.entities || {}));
    }

    if (isErrorGetTag) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(getTagError?.data?.message);
    }
  }, [isSuccessGetTag, isErrorGetTag, getTagError, getTagData]);

  const handleAddBlog = async (e) => {
    e.preventDefault();

    try {
      await addBlog({
        title,
        tags: selectedTags,
        body,
        author,
        date,
        slika: postImage,
        tip: isPrivate,
      });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const handleAddTag = async (e) => {
    e.preventDefault();

    try {
      await addTag({ naziv: newTag });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const handleDeleteTag = async (id) => {
    try {
      await deleteTag({ id: id });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  // useEffect(() => {
  //   console.log("tags =>", tags);
  //   console.log("tags =>", newTag);
  // }, [tags, tags]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const blog = {
      title,
      body,
      author,
      date: handleClick(),
      slika: postImage.myFile,
    };
  };

  // Upload a new profile picture
  const uploadImage = async (newImage) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/profilePic`, //Zabog id
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify(newImage),
        }
      );

      if (!response.ok) {
        throw new Error(`Error uploading image: ${response.statusText}`);
      }

      // console.log("File uploaded successfully");
      setPostImage(newImage);
    } catch (error) {
      console.error("Error uploading the file:", error);
    }
  };

  const handleTagChange = (event, tag) => {
    if (event.target.checked) {
      // Dodaj tag u niz ako je checkbox označen
      setSelectedTags((prevSelectedTags) => [...prevSelectedTags, tag.naziv]);
    } else {
      // Ukloni tag iz niza ako je checkbox odznačen
      setSelectedTags((prevSelectedTags) =>
        prevSelectedTags.filter((t) => t !== tag.naziv)
      );
    }
  };

  // Handle file upload
  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const base64 = await convertToBase64(file);
      const newImage = { myFile: base64 };
      setPostImage(newImage); // Update the state for immediate feedback
      //   uploadImage(newImage); // Automatically upload the file
    }
  };

  // const handleUpload = async (event) => {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("image", file);

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/blog/${id}/upload`,
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );
  //     // const response = await fetch(
  //     //   `http://localhost:5000/api/users/${id}/upload`,
  //     //   {
  //     //     method: "POST",
  //     //     body: formData,
  //     //   }
  //     // );
  //     const data = await response.json();
  //     setImageUrl(`${process.env.REACT_APP_API_URL}${data.imageUrl}`);
  //     // setImageUrl(`http://localhost:5000${data.imageUrl}`);
  //     //ZMANENI URL
  //     // alert("Profilna slika uspešno postavljena!");
  //     // window.location.reload();
  //   } catch (error) {
  //     console.error("Greška pri uploadu slike", error);
  //   }
  // };

  const handleClick = () => {
    const current = new Date();
    const cDate =
      current.getFullYear() +
      "-" +
      (current.getMonth() + 1) +
      "-" +
      current.getDate();
    const cTime =
      current.getHours() +
      ":" +
      current.getMinutes() +
      ":" +
      current.getSeconds();
    const dateTime = cDate + " " + cTime;
    return dateTime;
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
    ],
  };

  return (
    <>
      <br />
      <div className="create max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-4">Dodaj novi blog:</h1>
        <form onSubmit={handleSubmit}>
          {/* <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Blog naslov:
            </label>
            <input
              type="text"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div> */}
          <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Blog naslov:
            </label>
            <input
              type="text"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 mb-4"
            />

            <div className="flex items-center space-x-4">
              <span className="text-lg font-semibold">
                {isPrivate ? "Privatan" : "Javan"}
              </span>

              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only" // Sakriva input ali ga zadržava u DOM-u
                  checked={isPrivate}
                  onChange={handleSwitchChange}
                />
                <span
                  className={`w-10 h-5 bg-gray-300 rounded-full transition-colors duration-300 ease-in-out 
              ${isPrivate ? "bg-green-500" : "bg-gray-400"}`}
                >
                  <span
                    className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out
                ${isPrivate ? "translate-x-5" : "translate-x-1"}`}
                  ></span>
                </span>
              </label>
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Kreiraj nov tag:
            </label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                value={newTag}
                onChange={(e) => setNewTag(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Unesite novi tag"
              />
              <button
                onClick={handleAddTag}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Dodaj Tag
              </button>
            </div>
          </div>

          {/* <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Izaberi tag:
            </label>
            <div className="space-y-2">
              {tags.map((tag, index) => (
                <div className="flex items-center justify-between" key={index}>
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      value={tag.naziv}
                      className="form-checkbox"
                    />
                    {tag.naziv}
                  </label>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() => handleRemoveTag(tag._id)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div> */}
          <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Izaberi tag:
            </label>
            <div className="flex flex-wrap gap-4">
              {" "}
              {/* Flexbox za horizontalni raspored */}
              {tags.map((tag, index) => (
                <div className="flex items-center" key={index}>
                  <label className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      value={tag.naziv}
                      className="form-checkbox"
                      onChange={(event) => handleTagChange(event, tag)}
                    />
                    {tag.naziv}
                  </label>
                  <button
                    className="ml-2 text-red-500 hover:text-red-700"
                    onClick={() => handleDeleteTag(tag._id)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-4">
            {/* <label className="block text-lg font-medium mb-2">Blog telo:</label>
            <textarea
              required
              value={body}
              onChange={(e) => setBody(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 h-40"
            ></textarea> */}
            <ReactQuill
              value={body}
              onChange={(value) => setBody(value)}
              className="w-full focus:outline-none focus:ring-2 focus:ring-indigo-500 h-80"
              theme="snow"
            />
          </div>
          <br />
          <br />

          <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Blog autor:
            </label>
            <input
              type="text"
              required
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div className="mb-4">
            <label className="block text-lg font-medium mb-2">
              Odpremi sliku:
            </label>
            <input
              type="file"
              label="Image"
              name="myFile"
              id="file-upload"
              accept=".jpeg, .png, .jpg"
              onChange={handleFileUpload}
              className="block w-full text-sm text-gray-500 file:py-2 file:px-4 file:border file:border-gray-300 file:rounded-md file:bg-blue-500 file:text-white hover:file:bg-blue-600"
            />
          </div>

          {postImage.myFile && (
            <div className="mb-4">
              <label className="block text-lg font-medium mb-2">Slika:</label>
              <img
                src={postImage.myFile}
                alt="Neka slika ovde"
                className="w-full h-auto rounded-md shadow-sm"
              />
            </div>
          )}

          <div className="mt-6">
            <button
              onClick={handleAddBlog}
              className="w-full py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
            >
              Dodaj Blog
            </button>
          </div>
        </form>
      </div>
      <br />
      <br />
      <br />
      <br />
    </>

    // <div className="create">
    //   <h1>Dodaj blog:</h1>
    //   <form onSubmit={handleSubmit}>
    //     <label>Blog naslov:</label>
    //     <input
    //       type="text"
    //       required
    //       value={title}
    //       onChange={(e) => setTitle(e.target.value)}
    //     />

    //     <label>Kreiraj nov tag:</label>
    //     <div className="tag-container">
    //       <div className="input-section">
    //         <input
    //           type="text"
    //           value={newTag}
    //           onChange={(e) => setNewTag(e.target.value)} // Updateuj vrednost inputa
    //           placeholder=""
    //         />
    //         <button onClick={handleAddTag} className="add-button">
    //           Dodaj Tag
    //         </button>
    //       </div>
    //     </div>

    //     <label>Izaberi tag:</label>
    //     <div className="tags-display">
    //       {tags.map((tag, index) => (
    //         <div className="tag-item" key={index}>
    //           <label>
    //             <input type="checkbox" value={tag} />
    //             {tag}
    //           </label>
    //           <button
    //             className="remove-tag"
    //             onClick={() => handleRemoveTag(tag)}
    //           >
    //             X
    //           </button>
    //         </div>
    //       ))}
    //     </div>

    //     <label>Blog telo:</label>
    //     <textarea
    //       required
    //       value={body}
    //       onChange={(e) => setBody(e.target.value)}
    //       className="texta"
    //     ></textarea>
    //     <label>Blog autor:</label>
    //     <input
    //       type="text"
    //       required
    //       value={author}
    //       onChange={(e) => setAuthor(e.target.value)}
    //     />
    //     <label>Odpremi sliku:</label>
    //     <input
    //       type="file"
    //       label="Image"
    //       name="myFile"
    //       id="file-upload"
    //       accept=".jpeg, .png, .jpg"
    //       onChange={handleFileUpload}
    //     />

    //     <label>Slika:</label>
    //     <img
    //       src={postImage.myFile}
    //       alt="Neka slika ovde"
    //       className="profile-image"
    //     />

    //     <button onClick={handleClick}>Dodaj Blog</button>
    //   </form>
    // </div>
  );
};

export default Create;

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.onerror = (error) => reject(error);
  });
}

// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
//             <ReactQuill
//               value={body}
//               onChange={(e) => setBody(e.target.value)}
//               className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 h-40"
//               theme="snow"
//             />
